<script setup lang="ts">
import { ref } from 'vue'

const isActiveSystem = ref('penagihan')

const featureList = [
  {
    title: 'Integrasi plug-n-play',
    desc: 'Memungkinkan integrasi pembayaran super cepat tanpa coding rumit dan setup ribet. Bisnis Anda bisa langsung live dan terima semua pembayaran!',
    img: '/img/feature-assets/feature-2.png',
  },
  {
    title: 'Efisiensi Pengelolaan Transaksi',
    desc: 'Kelola ribuan transaksi dengan dashboard yang intuitif dan real-time monitoring system',
    img: '/img/feature-assets/feature-1.png',
  },
  {
    title: 'Otomatisasi Billing',
    desc: 'Automatic invoice generation dan reminder system untuk mengoptimalkan collection rate',
    img: '/img/feature-assets/feature-3.png',
  },
  {
    title: 'Multi-Payment Integration',
    desc: 'Integrasi dengan berbagai metode pembayaran untuk fleksibilitas transaksi bisnis Anda',
    img: '/img/feature-assets/feature-4.png',
  },
  {
    title: 'Rekomendasi Cashflow Management',
    desc: 'Monitor, analisa, dan optimalkan arus kas bisnis Anda dalam satu dashboard',
    img: '/img/feature-assets/feature-5.png',
  },
]

const solutionBusinessList = [
  {
    title: 'Toko Online / UMKM',
    list: [
      'Terima semua pembayaran via online tanpa ribet',
      'Langsung aktif dengan hanya upload KTP (GoPay, QRIS, Transfer Bank)',
      'Notifikasi real-time saat pembayaran masuk',
    ],
    img: '/img/feature-assets/solution-partner-1.png',
  },
  {
    title: 'Startup & Ecommerce',
    list: [
      'Integrasi mudah ke website atau aplikasi',
      'Laporan transaksi lengkap dalam satu dashboard',
      'Aman untuk transaksi dalam jumlah besar',
    ],
    img: '/img/feature-assets/solution-partner-2.png',
  },
  {
    title: 'Korporasi & Enterprise',
    list: [
      'Sistem terintegrasi dengan API untuk kebutuhan khusus',
      'Kelola pembayaran dari banyak cabang sekaligus',
      'Multi-admin & keamanan tingkat tinggi',
    ],
    img: '/img/feature-assets/solution-partner-3.png',
  },
]

const systemList = [
  {
    name: 'Penagihan',
    key: 'penagihan',
    title: 'Tagih Lebih Rapi, Cepat, dan Otomatis',
    list: [
      'Buat tagihan dalam hitungan detik',
      'Kirim langsung ke WhatsApp atau email',
      'Pantau status bayar real-time',
      'Integrasi ke sistem internal Anda via API',
    ],
    img: '/img/feature-assets/penagihan.png',
    mobileClass: 'xs:-bottom-[150px] xs:right-[0px]',
  },
  {
    name: 'Pembayaran',
    key: 'pembayaran',
    title: 'Terima Pembayaran Tanpa Ribet',
    list: [
      'Dukungan transfer bank, e-wallet, & kartu',
      'Auto-verifikasi tanpa input manual',
      'Laporan pembayaran otomatis',
      'Integrasikan sistem pembayaran Anda via API',
    ],
    img: '/img/feature-assets/pembayaran.png',
    mobileClass: 'xs:-bottom-[150px] xs:right-[0px]',
  },
  {
    name: 'QR Statis',
    key: 'qrstatis',
    title: 'Kelola Banyak QR, Semua Tercatat Otomatis',
    list: [
      'Buat QRIS berbeda untuk tiap outlet, kasir',
      'Kirim tagihan ke tujuan secara online',
      'Gunakan sistem pembayaran online',
      'Lacak seluruh tagihan hanya dalam 1 klik',
    ],
    img: '/img/feature-assets/qr-statis.png',
    mobileClass: 'xs:-bottom-[150px] xs:right-[0px]',
  },
]

const activeCheckmark = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 16.5005C4.85775 16.5005 1.5 13.1427 1.5 9.00049C1.5 4.85824 4.85775 1.50049 9 1.50049C13.1422 1.50049 16.5 4.85824 16.5 9.00049C16.5 13.1427 13.1422 16.5005 9 16.5005ZM8.25225 12.0005L13.5547 6.69724L12.4943 5.63674L8.25225 9.87949L6.1305 7.75774L5.07 8.81824L8.25225 12.0005Z" fill="url(#a_check_active)"/><defs><linearGradient id="a_check_active" x1="1.01172" y1="-0.63701" x2="25.0757" y2="7.80192" gradientUnits="userSpaceOnUse"><stop stop-color="#FFCA53"/><stop offset="0.421639" stop-color="#FDDC92"/><stop offset="0.79569" stop-color="#FFEFCC"/><stop offset="1" stop-color="#FFEDC5"/></linearGradient></defs></svg>`

const inActiveCheckmark = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 16.5005C4.85775 16.5005 1.5 13.1427 1.5 9.00049C1.5 4.85824 4.85775 1.50049 9 1.50049C13.1422 1.50049 16.5 4.85824 16.5 9.00049C16.5 13.1427 13.1422 16.5005 9 16.5005ZM8.25225 12.0005L13.5547 6.69724L12.4943 5.63674L8.25225 9.87949L6.1305 7.75774L5.07 8.81824L8.25225 12.0005Z" fill="url(#a_check_inactive)"/><defs><linearGradient id="a_check_inactive" x1="-0.887544" y1="-11.1037" x2="23.8338" y2="-6.62543" gradientUnits="userSpaceOnUse"><stop stop-color="#FECBD4"/><stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8"/><stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85"/><stop offset="1" stop-color="#8A008A"/></linearGradient></defs></svg>`

function onActiveSystem(key: string) {
  isActiveSystem.value = key
  const container = document.querySelector('.scrollingWrapper')
  const element = document.getElementById(key)
  if (container && element) {
    const isMobile = window.innerWidth < 640
    const offsets: Record<string, number> = {
      penagihan: isMobile ? 20 : 600,
      pembayaran: isMobile ? 20 : 350,
      qrstatis: isMobile ? 0 : 100,
    }
    container.scrollTo({
      left: element.offsetLeft - offsets[key],
      behavior: 'smooth',
    })
  }
}
</script>

<template>
  <!-- Fitur Utama -->
  <section id="feature" class="container mx-auto mt-[80px] xs:px-4">
    <div class="p-8 border rounded-3xl border-neutral-200 xs:p-5 bgWhiteGradient">
      <div class="shadow-inners rounded-3xl" />
      <div class="relative z-10">
        <AnimateOnce initial-class="opacity-0 translate-y-8" animated-class="opacity-100 translate-y-0" :duration="600">
          <h2 class="text-neutral-800 text-[32px] font-medium font-geist">
            Fitur Utama
          </h2>
        </AnimateOnce>
        <div class="grid grid-cols-3 xs:grid-cols-1 gap-4 mt-6">
          <AnimateOnce
            v-for="(feature, i) in featureList"
            :key="feature.title"
            initial-class="opacity-0 translate-y-10"
            animated-class="opacity-100 translate-y-0"
            :duration="600"
            :delay="i * 100"
            class-name="col-span-1 xs:col-span-3 border rounded-3xl max-h-[380px] xs:max-h-none h-full border-neutral-200 bgWhiteGradient px-[10px] pt-[10px] pb-5"
          >
            <div class="shadow-inners rounded-3xl" />
            <img :src="feature.img" class="object-contain" alt="feature">
            <h3 class="mx-4 mt-3 text-2xl xs:text-xl xs:mx-[10px] font-medium text-neutral-800 font-geist">
              {{ feature.title }}
            </h3>
            <p class="mt-[6px] mx-4 xs:mx-[10px] mr-[30px] text-base text-neutral-800 font-geist">
              {{ feature.desc }}
            </p>
          </AnimateOnce>
        </div>
      </div>
    </div>
  </section>

  <!-- Solusi -->
  <section
    id="solusi"
    class="container mx-auto mt-20 xs:mt-[56px] md:px-[130px] xs:pb-[100px] pb-[210px] xs:px-4"
  >
    <AnimateOnce initial-class="opacity-0 translate-y-8" animated-class="opacity-100 translate-y-0" :duration="600">
      <h2 class="text-center font-medium text-neutral-800 xs:text-[30px] text-[32px] font-geist">
        Solusi Payment Gateway untuk Evolusi <br class="xs:hidden">
        Bisnis Anda
      </h2>
    </AnimateOnce>
    <div class="relative grid grid-cols-3 xs:grid-cols-1 gap-4 mt-8">
      <AnimateOnce
        v-for="(solution, i) in solutionBusinessList"
        :key="solution.title"
        initial-class="opacity-0 translate-y-10"
        animated-class="opacity-100 translate-y-0"
        :duration="600"
        :delay="i * 120"
        class-name="w-full col-span-1 xs:col-span-3 z-10 px-8 h-[470px] xs:mb-20 relative border rounded-2xl border-neutral-200 bgWhiteGradient py-9"
      >
        <div class="shadow-inners rounded-2xl" />
        <h3 class="text-2xl font-medium text-neutral-800 font-geist">
          {{ solution.title }}
        </h3>
        <ul class="px-6 mt-2 list-disc">
          <li
            v-for="item in solution.list"
            :key="item"
            class="text-lg leading-relaxed xs:text-base text-neutral-800 font-geist"
          >
            {{ item }}
          </li>
        </ul>
        <img
          class="absolute -bottom-[135px] z-10 w-[280px] xs:w-[350px] xs:-bottom-[180px] xs:-right-[95px] object-contain -right-[75px]"
          :src="solution.img"
          alt="solution"
        >
      </AnimateOnce>
      <img
        class="absolute top-[180px] -left-[90px] xs:hidden z-0 object-contain w-[140px]"
        src="/img/content-assets/ornament-1.png"
        alt="ornament"
      >
      <img
        class="absolute -top-[40px] -right-[90px] z-0 object-contain xs:-right-[50px] w-[140px]"
        src="/img/content-assets/ornament-1.png"
        alt="ornament"
      >
    </div>
  </section>

  <!-- System Tabs -->
  <section class="bg-[#FAFAFA]">
    <div class="container mx-auto py-[80px] overflow-x-hidden xs:px-4">
      <AnimateOnce initial-class="opacity-0 translate-y-8" animated-class="opacity-100 translate-y-0" :duration="600">
        <h2 class="text-neutral-800 text-[32px] xs:text-[30px] font-medium font-geist">
          Lebih dari sekadar payment gateway tapi, <br class="xs:hidden">
          partner strategis untuk monetisasi operasional <br class="xs:hidden">
          bisnis digital Anda.
        </h2>
      </AnimateOnce>
      <div class="mt-8">
        <div class="flex items-center gap-3">
          <button
            v-for="item in systemList"
            :key="item.key"
            :class="
              isActiveSystem === item.key
                ? 'bgGradientV2 text-white font-semibold shadow-sm'
                : 'font-normal text-neutral-500 bg-neutral-100 hover:bg-neutral-200'
            "
            class="px-5 py-1.5 text-sm duration-200 ease-in-out rounded-full font-geist"
            @click="onActiveSystem(item.key)"
          >
            {{ item.name }}
          </button>
        </div>
        <div
          class="flex items-start gap-4 pb-4 mt-8 overflow-x-auto snap-mandatory snap-x scrollingWrapper scrollBehaviorX"
        >
          <div
            v-for="ctn in systemList"
            :id="ctn.key"
            :key="ctn.key"
            :class="
              isActiveSystem === ctn.key
                ? 'bgGradientV2 rounded-xl shadow-md'
                : 'border border-neutral-200 bg-white rounded-xl opacity-80'
            "
            class="min-w-[628px] snap-start relative cursor-pointer xs:min-w-[340px] overflow-hidden xs:min-h-[550px] min-h-[440px] h-full transition-all duration-300"
            @click="onActiveSystem(ctn.key)"
          >
            <div v-if="isActiveSystem === ctn.key" class="shadow-inners rounded-xl" />
            <div class="max-w-[55%] xs:max-w-full p-[30px]">
              <span
                :class="
                  isActiveSystem === ctn.key
                    ? 'text-white/80 font-medium'
                    : 'text-neutral-500 font-normal'
                "
                class="text-xs uppercase tracking-widest"
              >
                {{ ctn.name }}
              </span>
              <h5
                :class="
                  isActiveSystem === ctn.key
                    ? 'text-white font-semibold'
                    : 'text-neutral-800 font-medium'
                "
                class="text-xl mt-2 leading-snug"
              >
                {{ ctn.title }}
              </h5>
              <ul class="mt-5">
                <li
                  v-for="item in ctn.list"
                  :key="item"
                  class="flex items-start gap-3 mb-2"
                >
                  <div
                    class="mt-[2px] shrink-0"
                    v-html="
                      isActiveSystem === ctn.key
                        ? activeCheckmark
                        : inActiveCheckmark
                    "
                  />
                  <span
                    class="text-sm leading-relaxed"
                    :class="
                      isActiveSystem === ctn.key
                        ? 'text-white'
                        : 'text-neutral-600'
                    "
                  >
                    {{ item }}
                  </span>
                </li>
              </ul>
              <img
                :src="ctn.img"
                :class="ctn.mobileClass"
                class="absolute bottom-8 -right-[50px] w-[400px] xs:w-[500px] xs:h-[450px] object-contain h-[360px]"
                alt="system"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Dark CTA -->
  <section class="bg-[#242424] relative overflow-hidden">
    <AnimateOnce initial-class="opacity-0 translate-y-8" animated-class="opacity-100 translate-y-0" :duration="600">
      <div
        class="container mx-auto py-[80px] xs:py-[50px] xs:px-6 flex relative z-10 xs:flex-col justify-between items-center gap-8"
      >
        <h2
          class="text-white xs:text-center xs:text-[28px] font-medium text-[30px] leading-snug font-geist"
        >
          Siap untuk mulai eksplorasi bersama <br class="xs:hidden">
          Rintisan Billing Partner?
        </h2>
        <button
          class="shrink-0 z-20 px-8 py-3.5 text-base font-semibold bg-white rounded-md xs:mt-2 text-neutral-800 hover:bg-neutral-50 transition-colors font-geist"
          @click="navigateTo('/daftar')"
        >
          Coba Sekarang
        </button>
      </div>
    </AnimateOnce>
    <img
      class="absolute right-0 w-[360px] top-1/2 -translate-y-1/2 object-contain opacity-20 pointer-events-none"
      src="/img/content-assets/ornament-rotate.png"
      alt="ornament"
    >
  </section>
</template>
